export enum ClassroomRole {
  Student = 0,
  Teacher = 1,
  TeachingAssistant = 2,
}
